<template>
    <div class="fundraising-page">
        <!-- Credit Score Dialog -->
        <v-dialog v-model="showCreditScoreDialog" max-width="800px">
            <v-card style="border-radius: 12px; overflow: hidden;">
                <v-card-title class="teal darken-2 white--text" style="background: linear-gradient(135deg, #00695C 0%, #004D40 100%);">
                    <v-icon left color="white">mdi-star-circle</v-icon>
                    <span class="headline font-weight-bold">Understanding Your Credit Score</span>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showCreditScoreDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pa-4" style="max-height: 600px; overflow-y: auto;">
                    <!-- Contenu du dialog (identique aux précédents) -->
                    <div class="credit-score-explanation">
                        <!-- ... Même contenu que les designs précédents ... -->
                    </div>
                </v-card-text>

                <v-card-actions class="pa-4" style="background: #f5f5f5;">
                    <v-btn color="teal darken-2" dark @click="showCreditScoreDialog = false" style="border-radius: 24px;">
                        <v-icon left small>mdi-check</v-icon>
                        Got it!
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Hero Section améliorée -->
        <div class="hero-section primary darken-2">
            <div class="hero-gradient"></div>
            <div class="hero-pattern"></div>

            <v-container class="hero-content">
                <!-- Welcome Badge -->
                <div class="welcome-badge" v-if="$store.state.isAuthenticated">
                    <span class="badge-icon">🚀</span>
                    <span class="badge-text">Welcome <strong class="notranslate username-text" translate="no">{{$store.state.user_info["user"]["username"]}}</strong>, to PettyCash: Fundraising</span>
                </div>
                <div class="welcome-badge" v-else>
                    <span class="badge-icon">🚀</span>
                    <span class="badge-text">Welcome to <strong>PettyCash: Fundraising</strong></span>
                </div>

                <!-- Credit Score Badge -->
                <div class="credit-score-badge" @click="showCreditScoreDialog = true">
                    <v-icon small class="credit-icon">mdi-star-circle</v-icon>
                    <span class="credit-text">Your Credit Score: <strong>{{ userCreditScore }}</strong></span>
                    <v-icon small class="info-icon">mdi-information-outline</v-icon>
                </div>

                <h1 class="hero-title">
                    We bring life into your
                    <span class="hero-title-accent">dream projects.</span>
                </h1>

                <!-- Animated Journey Illustration AVEC TAILLES D'ORIGINE -->
           <v-layout row wrap class="journey-flow">
            <v-flex wrap xs2 sm2 md2 lg2 class="journey-item" style="animation-delay: 0.1s">
                <v-btn outline fab color="white" class="outine-2 journey-btn">
                    <i class="fas fa-coins journey-large-icon"></i>
                </v-btn>
            </v-flex>

            <v-flex wrap xs2 sm2 md2 lg2 class="journey-item" style="animation-delay: 0.2s">
                <v-btn flat fab color="white" class="journey-btn-flat">
                    <i class="fas fa-plus journey-medium-icon"></i>
                </v-btn>
            </v-flex>

            <v-flex wrap xs2 sm2 md2 lg2 class="journey-item" style="animation-delay: 0.3s">
                <v-btn outline fab color="white" class="outine-2 journey-btn">
                    <i class="fas fa-hand-holding-usd journey-large-icon"></i>
                </v-btn>
            </v-flex>

            <v-flex wrap xs2 sm2 md2 lg2 class="journey-item" style="animation-delay: 0.4s">
                <v-btn flat fab color="white" class="journey-btn-flat">
                    <i class="fas fa-arrow-right journey-medium-icon"></i>
                </v-btn>
            </v-flex>

            <v-flex wrap xs2 sm3 md3 lg3 class="journey-item fundraising-item" style="animation-delay: 0.5s">
                <div class="fundraising-glow"></div>
                <v-img
                    :src="require('@/assets/funding.png')"
                    aspect-ratio="2"
                    contain
                    height="90"
                    width="150"
                    class="fundraising-image"
                ></v-img>
            </v-flex>
        </v-layout>
            </v-container>
        </div>

        <!-- Main Content -->
        <v-container class="main-content mt-5">
            <v-layout row>
                <v-flex xs12 md10 offset-md1 lg10 offset-lg1>
                    <v-card flat class="card--flex-toolbar" color="transparent">
                        <v-container fluid grid-list-lg>
                            <!-- Section Header -->
                            <v-layout row wrap>
                                <v-flex xs12 class="mt-0 pt-0 mb-2">
                                    <h3 class="white--text section-title">Explore Petty Ca$h Fundraising</h3>
                                </v-flex>
                            </v-layout>

                            <!-- Cards Grid amélioré -->
                            <v-layout row wrap>
                                <v-flex
                                    xs12 sm6 md6 lg3
                                    v-for="item in links"
                                    :key="item.id"
                                    class="pa-2"
                                >
                                    <v-hover v-slot="{ hover }">
                                        <v-card
                                            :class="['service-card', `elevation-${hover ? 12 : 4}`]"
                                            style="border-radius: 5px; font-size: small"
                                            :to="item.link"
                                        >
                                            <!-- Accent Border on Hover -->
                                            <div class="card-accent-border" :style="{ background: getAccentColor(item.color) }"></div>

                                            <!-- Gradient Overlay -->
                                            <div class="card-gradient" :style="{ background: getCardGradient(item.color) }"></div>

                                            <!-- Card Header -->
                                            <v-layout row>
                                                <v-flex xs8>
                                                    <v-btn fab :color="item.color" class="mt-2 ml-3 mb-0 mr-2 white--text icon-btn">
                                                        <i :class="item.icon"></i>
                                                    </v-btn>
                                                </v-flex>

                                                <!-- Menu -->
                                                <v-flex xs4 v-if="!(item.title == 'Legal Bindings')" class="text-xs-right">
                                                    <v-menu bottom right>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                icon
                                                                flat
                                                                fab
                                                                class="menu-btn mt-2 ml-3 mb-0"
                                                                v-on="on"
                                                                @click.prevent="activateMenu(item.title)"
                                                            >
                                                                <i class="fa-solid fa-ellipsis-vertical fa-2x"></i>
                                                            </v-btn>
                                                        </template>
                                                        <v-list class="grey lighten-4 menu-list">
                                                            <v-list-tile
                                                                v-for="menuLink in menuItems"
                                                                :key="menuLink.title"
                                                                :to="menuLink.link"
                                                                class="menu-item"
                                                            >
                                                                <v-list-tile-title>{{ menuLink.title }}</v-list-tile-title>
                                                            </v-list-tile>
                                                        </v-list>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Card Content -->
                                            <v-card-title primary-title class="pb-0 mt-0 pt-1" style="color: #424242">
                                                <div class="card-content">
                                                    <h5 class="subheading pl-0 pb-0 mb-0 card-title"><b>{{ item.title }}</b></h5>
                                                    <div class="caption mt-0 mb-0 pb-2 card-description">{{ item.description }}</div>

                                                    <div class="card-footer">
                                                        <span class="card-link primary--text text--darken-2">
                                                            Explore
                                                            <i class="fas fa-arrow-right card-arrow-icon"></i>
                                                        </span>
                                                    </div>
                                                </div>
                                            </v-card-title>
                                        </v-card>
                                    </v-hover>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            userCreditScore: 0,
            showCreditScoreDialog: false,
            menuItems: [],
            links: [
                {
                    id: '1',
                    title: 'Projects',
                    description: 'View and learn of our current projects which you can invest into and buy shares or donate.',
                    icon: 'fa-solid fa-project-diagram fa-2x',
                    color: 'orange',
                    link: '/funding/projects/types/active',
                    add_link: false
                },
                {
                    id: '3',
                    title: 'Events',
                    description: 'View, create and invite others to raise funds for one-time events',
                    icon: 'fa-solid fa-calendar-alt fa-2x',
                    color: 'blue',
                    link: '/funding/events/types/active',
                    add_link: false
                },
                {
                    id: '4',
                    title: 'Contact Us',
                    description: 'Get in contact with us if you have any worries/suggestions',
                    icon: 'fa-solid fa-address-card fa-2x',
                    color: 'green',
                    link: '/funding/contact_us/all',
                    add_link: false
                },
                {
                    id: '5',
                    title: 'Legal Bindings',
                    description: 'Learn of the rules and ways of fundraising with Petty Cash',
                    icon: 'fa-solid fa-file-contract fa-2x',
                    color: 'purple',
                    link: '/funding/legal_binding/all',
                    add_link: false
                }
            ]
        };
    },
    mounted() {
        document.title = "PettyCash | Fundraising";
        this.getUserCreditScore();
    },
    methods: {
        async getUserCreditScore() {
            try {
                if (this.$store.state.user_info && this.$store.state.user_info.user_credit && this.$store.state.user_info.user_credit[0]) {
                    this.userCreditScore = this.$store.state.user_info.user_credit[0].credit || 0;
                } else {
                    const response = await axios.get('/api/v1/home/get/user/info/');
                    if (response.data[0] && response.data[0].user_credit && response.data[0].user_credit[0]) {
                        this.userCreditScore = response.data[0].user_credit[0].credit || 0;
                    }
                }
            } catch (error) {
                console.error('Error fetching credit score:', error);
                this.userCreditScore = 0;
            }
        },
        activateMenu(title) {
            if (title == "Projects") {
                this.menuItems = [
                    {
                        "title": "Active",
                        "link": "/funding/projects/types/active",
                    },
                    {
                        "title": "Terminated",
                        "link": "/funding/projects/types/terminated",
                    },
                    {
                        "title": "Most Bought",
                        "link": "/funding/projects/types/my_projects",
                    },
                    {
                        "title": "Create New Project",
                        "link": "/funding/projects/create/new_project",
                    },
                ];
            }
            else if (title == "Events") {
                this.menuItems = [
                    {
                        "title": "Active",
                        "link": "/funding/events/types/active",
                    },
                    {
                        "title": "Terminated",
                        "link": "/funding/events/types/terminated",
                    },
                    {
                        "title": "My Events",
                        "link": "/funding/events/types/my_events",
                    },
                    {
                        "title": "Create New Event",
                        "link": "/funding/events/create/new_event",
                    },
                ];
            }
            else if (title == "Contact Us") {
                this.menuItems = [
                    {
                        "title": "All Chats",
                        "link": "/funding/contact_us/all",
                    },
                    {
                        "title": "Create New Chat",
                        "link": "/funding/contact_us/new_ticket",
                    },
                ];
            }
        },
        // Méthodes pour les gradients et couleurs
        getCardGradient(color) {
            const gradients = {
                orange: 'linear-gradient(135deg, rgba(255, 152, 0, 0.04) 0%, rgba(255, 152, 0, 0) 100%)',
                blue: 'linear-gradient(135deg, rgba(33, 150, 243, 0.04) 0%, rgba(33, 150, 243, 0) 100%)',
                green: 'linear-gradient(135deg, rgba(76, 175, 80, 0.04) 0%, rgba(76, 175, 80, 0) 100%)',
                purple: 'linear-gradient(135deg, rgba(156, 39, 176, 0.04) 0%, rgba(156, 39, 176, 0) 100%)',
            };
            return gradients[color] || gradients.orange;
        },
        getAccentColor(color) {
            const accents = {
                orange: '#FF9800',
                blue: '#2196F3',
                green: '#4CAF50',
                purple: '#9C27B0',
            };
            return accents[color] || accents.orange;
        }
    },
};
</script>

<style scoped>
/* Styles de base - TAILLES D'ORIGINE CONSERVÉES */
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&family=DM+Sans:wght@400;500;700&display=swap');

.fundraising-page {
    min-height: 100vh;
    background: #f5f5f5;
    font-family: 'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* ===== HERO SECTION ===== */
.hero-section {
    position: relative;
    padding: 40px 0;
    min-height: 420px;
    overflow: hidden;
}

.hero-gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background:
        radial-gradient(circle at 20% 50%, rgba(156, 39, 176, 0.12) 0%, transparent 50%),
        radial-gradient(circle at 80% 30%, rgba(255, 152, 0, 0.08) 0%, transparent 50%);
    pointer-events: none;
}

.hero-pattern {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        radial-gradient(circle at 20px 20px, rgba(255, 255, 255, 0.02) 2px, transparent 0);
    background-size: 40px 40px;
    pointer-events: none;
}

.hero-content {
    position: relative;
    z-index: 1;
    text-align: center;
}

.welcome-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: rgba(255, 255, 255, 0.12);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 8px 16px;
    border-radius: 50px;
    color: white;
    font-size: 14px;
    margin-bottom: 12px;
    animation: slideInDown 0.6s ease-out;
}

.badge-icon {
    font-size: 16px;
}

.badge-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.badge-text strong {
    font-weight: 700;
}

/* Credit Score Badge */
.credit-score-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.2), rgba(255, 165, 0, 0.2));
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 215, 0, 0.5);
    padding: 10px 20px;
    border-radius: 50px;
    color: white;
    font-size: 15px;
    margin-bottom: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    animation: pulseGlow 2s infinite, slideInDown 0.6s ease-out 0.1s both;
}

.credit-score-badge:hover {
    background: linear-gradient(135deg, rgba(255, 215, 0, 0.3), rgba(255, 165, 0, 0.3));
    transform: scale(1.05);
    box-shadow: 0 0 25px rgba(255, 215, 0, 0.6);
}

.credit-icon {
    color: #FFD700;
    font-size: 20px !important;
}

.credit-text {
    font-weight: 500;
}

.credit-text strong {
    font-weight: 700;
    color: #FFD700;
}

.info-icon {
    color: #FFD700;
    font-size: 18px !important;
}

@keyframes pulseGlow {
    0%, 100% {
        box-shadow: 0 0 10px rgba(255, 215, 0, 0.4);
    }
    50% {
        box-shadow: 0 0 20px rgba(255, 215, 0, 0.8), 0 0 30px rgba(255, 165, 0, 0.5);
    }
}

.hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: clamp(20px, 4vw, 28px);
    font-weight: 600;
    color: white;
    line-height: 1.3;
    margin-bottom: 32px;
    animation: slideInDown 0.6s ease-out 0.2s both;
    padding: 0 16px;
}

.hero-title-accent {
    display: block;
    background: linear-gradient(135deg, #FF9800 0%, #FF5722 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-top: 4px;
    font-weight: 700;
}

/* ===== JOURNEY FLOW - TAILLES D'ORIGINE ===== */
.journey-flow {
    animation: fadeInUp 0.6s ease-out 0.3s both;
    justify-content: center;
    align-items: center;
}

.journey-item {
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Boutons avec taille d'origine - LES MÊMES QUE VOTRE DESIGN */
.journey-btn {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.journey-btn-flat {
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* Animations au hover seulement */
.journey-btn:hover {
    transform: translateY(-5px) scale(1.05) !important;
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25) !important;
}

.journey-btn-flat:hover {
    transform: scale(1.1) !important;
}

.fundraising-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.fundraising-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 140px;
    height: 140px;
    background: radial-gradient(circle, rgba(255, 152, 0, 0.25) 0%, transparent 70%);
    border-radius: 50%;
    animation: pulse 2s ease-in-out infinite;
    pointer-events: none;
}

@keyframes pulse {
    0%, 100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.5;
    }
    50% {
        transform: translate(-50%, -50%) scale(1.1);
        opacity: 0.7;
    }
}

.fundraising-image {
    position: relative;
    z-index: 1;
    filter: drop-shadow(0 4px 12px rgba(255, 152, 0, 0.3));
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.fundraising-item:hover .fundraising-image {
    transform: scale(1.05) rotate(5deg);
}

/* ===== MAIN CONTENT ===== */
.card--flex-toolbar {
    margin-top: -124px;
}

.section-title {
    font-size: 18px;
    font-weight: 400;
    animation: fadeInUp 0.6s ease-out 0.3s both;
}

/* ===== SERVICE CARDS ===== */
.service-card {
    position: relative;
    background: white;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
}

/* Accent border that appears on hover */
.card-accent-border {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    opacity: 0;
    transition: opacity 0.4s;
}

.service-card:hover .card-accent-border {
    opacity: 1;
}

.card-gradient {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 0.4s;
    pointer-events: none;
}

.service-card:hover .card-gradient {
    opacity: 1;
}

/* Boutons d'icônes - taille d'origine conservée */
.icon-btn {
    position: relative;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.icon-btn i {
    color: #ffffff !important;
}

/* Effets hover pour les boutons d'icônes */
.service-card:hover .icon-btn {
    transform: scale(1.08) rotate(5deg) !important;
}

/* Effets glow par couleur */
.service-card:hover .icon-btn.orange {
    box-shadow: 0 0 0 8px rgba(255, 152, 0, 0.2);
}

.service-card:hover .icon-btn.blue {
    box-shadow: 0 0 0 8px rgba(33, 150, 243, 0.2);
}

.service-card:hover .icon-btn.green {
    box-shadow: 0 0 0 8px rgba(76, 175, 80, 0.2);
}

.service-card:hover .icon-btn.purple {
    box-shadow: 0 0 0 8px rgba(156, 39, 176, 0.2);
}

/* ===== CARD CONTENT ===== */
.card-content {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.card-title {
    font-size: 16px;
    line-height: 1.3;
}

.card-description {
    font-size: 12px;
    line-height: 1.5;
    flex: 1;
}

.card-footer {
    display: flex;
    align-items: center;
    padding-top: 8px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    margin-top: 8px;
}

.card-link {
    font-size: 13px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: gap 0.3s;
}

.service-card:hover .card-link {
    gap: 10px;
}

.card-arrow-icon {
    font-size: 11px !important;
    display: inline-block;
    transition: transform 0.3s;
}

.service-card:hover .card-arrow-icon {
    transform: translateX(3px);
}

/* ===== MENU ===== */
.menu-list {
    border-radius: 4px !important;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.menu-item {
    transition: background 0.2s;
    font-size: 14px;
}

.menu-item:hover {
    background: rgba(0, 0, 0, 0.05) !important;
}

/* ===== ANIMATIONS ===== */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideInDown {
    from {
        opacity: 0;
        transform: translateY(-15px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ===== RESPONSIVE DESIGN ===== */
/* Mobile */
@media (max-width: 599px) {
    .hero-section {
        min-height: 300px;
        padding: 24px 0;
    }

    .welcome-badge {
        font-size: 12px;
        padding: 6px 12px;
        max-width: 90%;
    }

    .credit-score-badge {
        font-size: 12px;
        padding: 8px 16px;
    }

    .hero-title {
        font-size: 16px;
        margin-bottom: 24px;
    }

    .fundraising-image {
        height: 70px !important;
        width: 120px !important;
    }

    .fundraising-glow {
        width: 100px;
        height: 100px;
    }

    .card--flex-toolbar {
        margin-top: -101px;
    }

    .section-title {
        font-size: 16px;
    }

    .card-title {
        font-size: 14px !important;
    }

    .card-description {
        font-size: 11px !important;
    }
}

/* Tablettes */
@media (min-width: 600px) and (max-width: 959px) {
    .hero-section {
        min-height: 340px;
        padding: 32px 0;
    }

    .welcome-badge {
        font-size: 13px;
    }

    .hero-title {
        font-size: 20px;
    }

    .fundraising-image {
        height: 80px !important;
        width: 130px !important;
    }

    .card--flex-toolbar {
        margin-top: -100px;
    }

    .section-title {
        font-size: 17px;
    }
}

/* Desktop */
@media (min-width: 960px) {
    .hero-section {
        min-height: 380px;
    }

    .hero-title {
        font-size: 28px;
    }
}

/* Print styles */
@media print {
    .hero-gradient,
    .hero-pattern,
    .fundraising-glow {
        display: none;
    }
}

/* Animation pour les éléments */
.v-flex {
    opacity: 0;
    animation: fadeInUp 0.5s ease forwards;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Retard d'animation pour les cartes */
.v-flex:nth-child(1) { animation-delay: 0.1s; }
.v-flex:nth-child(2) { animation-delay: 0.2s; }
.v-flex:nth-child(3) { animation-delay: 0.3s; }
.v-flex:nth-child(4) { animation-delay: 0.4s; }

/* ===== STYLES ORIGINAUX CONSERVÉS ===== */
.outine-2 {
    border: 2px solid white;
}

@media (max-width: 499px) {
    .saving_heading{
        font-size: 12px
    }
}

.learn-more-btn {
    text-transform: initial;
    text-decoration: underline;
}

/* Conserver les styles originaux du v-card */
.v-card {
    border-radius: 5px;
    font-size: small;
}

.v-card-title {
    color: #424242;
}

.v-card-title .subheading {
    font-size: 14px;
}

.v-card-title .caption {
    font-size: 12px;
}

/* Style pour le bouton menu */
.menu-btn i {
    color: #757575;
}

.menu-btn:hover i {
    color: #424242;
}
/* ===== CORRECTION DES ICÔNES TROP PETITES ===== */
.journey-large-icon {
    font-size: 2.5em !important; /* Équivalent à fa-3x mais mieux proportionné */
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.journey-medium-icon {
    font-size: 2em !important; /* Équivalent à fa-2.5x */
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* S'assurer que les boutons sont assez grands */
.journey-btn,
.journey-btn-flat {
    width: 64px !important;
    height: 64px !important;
    min-width: 64px !important;
}

/* Responsive */
@media (max-width: 599px) {
    .journey-btn,
    .journey-btn-flat {
        width: 52px !important;
        height: 52px !important;
        min-width: 52px !important;
    }

    .journey-large-icon {
        font-size: 2em !important;
    }

    .journey-medium-icon {
        font-size: 1.6em !important;
    }
}

@media (min-width: 600px) and (max-width: 959px) {
    .journey-btn,
    .journey-btn-flat {
        width: 60px !important;
        height: 60px !important;
        min-width: 60px !important;
    }

    .journey-large-icon {
        font-size: 2.2em !important;
    }

    .journey-medium-icon {
        font-size: 1.8em !important;
    }
}

/* Animation au hover */
.journey-btn:hover .journey-large-icon,
.journey-btn:hover .journey-medium-icon {
    transform: scale(1.1);
    transition: transform 0.3s ease;
}

.journey-btn-flat:hover .journey-large-icon,
.journey-btn-flat:hover .journey-medium-icon {
    transform: scale(1.1);
    transition: transform 0.3s ease;
}
</style>
